import React from 'react'
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import _ from 'lodash';
import styled from '@emotion/styled';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const UISwipeableDrawer = (props) => {
    const app = useSelector(state => state.app)

    const toggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        props?.setOpen(open);
    };

    const ResponsiveDrawer = styled(props => {
        return (
            <SwipeableDrawer

                {...props}
            >
                <AppBar sx={{ position: 'relative',
                background: app?.theme === 'dark' ? '#202529' : '#237FEA',
                display: props?.appBar === false && 'none',
                 }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="primary"
                            onClick={toggleDrawer(false)}
                            aria-label="close"
                        >
                            <Close />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }}  variant="h6" component="div">
                            {_.get(props, 'title', '')}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Box style={{ padding: props?.padding || '15px' }}>
                    {_.get(props, 'jsx', <></>)}
                </Box>
            </SwipeableDrawer>
        )
    })(({ theme }) => ({
        [theme.breakpoints.up("md")]: {
            width: props?.width || "25%",
            '& .MuiDrawer-paper': {
                width: props?.width || "25%",
                background:app?.theme=='light'&&'#fff'
            },
        },
        [theme.breakpoints.down("md")]: {
            width: "95%",
            '& .MuiDrawer-paper': {
                width: "95%",
                background:app?.theme=='light'&&'#fff'
            },
        },
    }));

    return (
        <>
            <ResponsiveDrawer
                anchor={_.get(props, 'anchor', 'right')}
                open={_.get(props, 'open', false)}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                {...props}
            />
        </>
    )
}

export default UISwipeableDrawer